import { Directive, HostBinding, Attribute } from '@angular/core';

@Directive({
    selector: '[matInput]',
    standalone: false
})
export class AutocompleteOffDirective {

    @HostBinding('attr.autocomplete') auto;
    @HostBinding('attr.type') inputType;

    constructor(
        @Attribute('autocomplete') autocomplete: string,
        @Attribute('type') type: string
    ) {
        this.auto = autocomplete || 'off';
        this.inputType = type || 'text';
    }

}
